module.exports = __webpack_public_path__ + "img/12_33.7b87f88b.png";